/**
 * @desc 格式化数字字符串
 * @param parent - 父级属性
 * @param prop - 当前属性
 * @param number -输入数字内容
 * @param decimals - 保留几位小数
 * @param index - 若为数组，则表示当前数据所在数组中的索引
 * @return string
 */
export function formatNumber(parent, prop, number, decimals, index) {
    if (number !== "") {
        let formatNumber = "";
        //去掉非法字符
        number = (number + '').replace(/[^\d.]/g, '')
        // 必须保证第一个为数字而不是. 输入第一位为.默认补充0
            .replace(/^\./g, '0.')
            // 保证只有出现一个.而没有多个.
            .replace(/\.{2,}/g, '.')
            // 保证.只出现一次，而不能出现两次以上
            .replace('.', '$#$')
            .replace(/\./g, '')
            .replace('$#$', '.');
        let strs = number.split('.');
        if (strs.length === 1) {
            formatNumber = strs[0];
        } else if (strs.length > 1) {
            if (strs[1].length > decimals) {
                strs[1] = strs[1].substring(0, decimals);
            }
            formatNumber = strs.join('.');
        }

        switch (parent) {
            case 'search':
                this.search[prop] = formatNumber;
                break;
            case 'formData':
                this.formData[prop] = formatNumber;
                break;
            case 'bkCargo':
                this.bkCargo[prop] = formatNumber;
                break;
            case 'bkImos':
                this.bkCargo.bkImos[index][prop] = formatNumber;
                break;
            case 'bkReefers':
                this.bkCargo.bkReefers[index][prop] = formatNumber;
                break;
            case 'bkAks':
                this.bookingHead.bkAks[index][prop] = formatNumber;
                break;
            case 'bkContainers':
                this.bkContainers[index][prop] = formatNumber;
                break;
            case 'estimate':
                this.estimate[prop] = formatNumber;
                break;
            case 'editBkContainers':
                this.editBkContainers[index][prop] = formatNumber;
                break;
            case 'tableHBLInfo':
                this.tableHBLInfo[index][prop] = formatNumber;
                break;
            case 'vgmContainerUploadTableData':
                this.vgmContainerUploadTableData[index][prop] = formatNumber;
                break;
        }
    }
}

/**
 * @desc 输入内容转换成大写
 * 允许输入：中文汉字、中文符号、英文字母、英文符号、阿拉伯数字
 * 清除并提示：其他语言字符（如日文、韩文等）
 * @param parent - 父级属性
 * @param prop - 当前属性
 * @param value -输入内容
 * @param index - 若为数组，则表示当前数据所在数组中的索引
 * @return string
 */
export function formatUpper(parent, prop, value, index) {
    // 生成字段错误键名（用于存储错误信息）
    // 只有当 index 明确存在且不为 0 时，才使用带索引的键名（用于数组字段）
    // 对于非数组字段，即使传入 0 也使用不带索引的键名
    const errorKey = (index !== undefined && index !== null && index !== 0) 
        ? `${parent}.${prop}.${index}` 
        : `${parent}.${prop}`;
    
    // 确保 fieldErrors 对象存在，如果不存在则初始化
    if (!this.fieldErrors) {
        this.fieldErrors = {};
    }
    
    if (value !== "" && value !== null && value !== undefined) {
        // 检测其他语言字符（除了中文、中文标点、ASCII字符之外的字符）
        // 允许的字符范围：
        // - ASCII字符：\x09 (Tab), \x0A (LF \n), \x0D (CR \r), \x20-\x7F (可打印字符)
        // - 中文汉字：\u4e00-\u9fa5
        // - 中文标点：\u3000-\u303f\uff00-\uffef
        const otherLanguageChars = value.match(/[^\x09\x0A\x0D\x20-\x7F\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/g);
        
        // 如果存在其他语言字符，清除并提示
        if (otherLanguageChars && otherLanguageChars.length > 0) {
            // 清除其他语言字符
            value = value.replace(/[^\x09\x0A\x0D\x20-\x7F\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/g, '');
            // 设置错误信息到 Vue 实例的 fieldErrors 对象中
            const errorMsg = this.$t("common.otherLanguageChars");
            // 确保 fieldErrors 对象已初始化
            if (!this.fieldErrors) {
                this.fieldErrors = {};
            }
            if (this.$set) {
                this.$set(this.fieldErrors, errorKey, errorMsg);
            } else {
                this.fieldErrors[errorKey] = errorMsg;
            }
            // 强制触发视图更新
            if (this.$forceUpdate) {
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            }
        } else {
            // 校验通过，清除错误信息（使用 delete 或设置为 undefined）
            if (this.fieldErrors && this.fieldErrors[errorKey]) {
                if (this.$set) {
                    this.$set(this.fieldErrors, errorKey, undefined);
                } else {
                    delete this.fieldErrors[errorKey];
                }
                // 强制触发视图更新
                if (this.$forceUpdate) {
                    this.$nextTick(() => {
                        this.$forceUpdate();
                    });
                }
            }
        }
        
        // 只对英文字母部分转大写，中文保持不变
        let newValue = value.replace(/[a-z]+/g, (match) => match.toUpperCase());
        
        switch (parent) {
            //舱单数据
            case 'bookingHead':
                this.bookingHead[prop] = newValue;
                break;
            //舱单扩展数据
            case 'bkExtend':
                this.bkExtend[prop] = newValue;
                break;
            //前程运输数据
            case 'bkRoutingPre':
                this.bkRoutingPre[prop] = newValue;
                break;
            //货物数据
            case 'bkCargo':
                this.bkCargo[prop] = newValue;
                break;
            //货物-危险品数据
            case 'bkImos':
                this.bkCargo.bkImos[index][prop] = newValue;
                break;
            //货物-冷箱数据
            case 'bkReefers':
                this.bkCargo.bkReefers[index][prop] = newValue;
                break;
            //特种箱数据
            case 'bkAks':
                this.bookingHead.bkAks[index][prop] = newValue;
                break;
            //集装箱数据
            case 'bkContainers':
                this.bkContainers[index][prop] = newValue;
                break;
            case 'editBkContainers':
                this.editBkContainers[index][prop] = newValue;
                break;
            //发货人数据
            case 'shipper':
                this.shipper[prop] = newValue;
                break;
            //收货人数据
            case 'consignee':
                this.consignee[prop] = newValue;
                break;
            //通知人1数据
            case 'notifier1':
                this.notifier1[prop] = newValue;
                break;
            //通知人2数据
            case 'notifier2':
                this.notifier2[prop] = newValue;
                break;
            //其他数据
            case 'formData':
                this.formData[prop] = newValue;
                break;
            case 'popover':
                this.popover[prop] = newValue;
                break;
            case 'search':
                this.search[prop] = newValue;
                break;
            case 'bkSearch':
                this.bkSearch[prop] = newValue;
                break;
            case 'tableHBLInfo':
                this.tableHBLInfo[index][prop] = newValue;
                break;
            //估价单数据
            case 'estimate':
                this.estimate[prop] = newValue;
                break;
            //估价单数据
            case 'ruleForm':
                this.ruleForm[prop] = newValue;
                break;
            //修改密码
            case 'pswForm':
                this.pswForm[prop] = newValue;
                break;
            //对账单明细数据
            case 'statementOfAccount':
                this.statementOfAccount[prop] = newValue;
                break;
            //发票明细数据
            case 'invoiceDoc':
                this.invoiceDoc[prop] = newValue;
                break;
            //VGM数据
            case 'vgmContainerUploadTableData':
                this.vgmContainerUploadTableData[index][prop] = newValue;
                break;
        }
    }
}

/**
 * @desc 校验单行输入内容字符个数
 * @param parent - 父级属性
 * @param prop - 当前属性
 * @param value -输入内容
 * @param row - 允许输入的最大行数
 * @param charLength - 单行允许输入的最大字符个数
 * @return string
 */
export function validateSingleLineCharLength(parent, prop, value, row, charLength,index) {
    let rowArray = [];
    if (value !== "") {//按行分割
        // 替换中文字符
        value = formatChinese2EnglishChar(value);
        rowArray = value.split("\n");
    }
    if (rowArray.length > 0) {
        //判断行数是否超过最大行数限制
        if (rowArray.length > row) {
            this.$message({
                showClose: true,
                message: parent === "bkCargo" ?
                    this.$t('message.charLengthLimitMsg2', {length: charLength, row: row}) :
                    this.$t('message.charLengthLimitMsg', {length: charLength, row: row}),
                type: 'error'
            });
        } else {
            //校验每行字符个数是否超过length个
            rowArray.forEach((item, index) => {
                if (item.length > charLength) {
                    //超过length部分截掉
                    item = item.substring(0, charLength);
                    rowArray[index] = item;
                    this.$message({
                        showClose: true,
                        message: parent === "bkCargo" ?
                            this.$t('message.charLengthLimitMsg2', {length: charLength, row: row}) :
                            this.$t('message.charLengthLimitMsg', {length: charLength, row: row}),
                        type: 'error'
                    });
                }
            })
        }
    }
    //组合单行数据
    let content = getArrayConcat(rowArray, row);
    switch (parent) {
        //货物数据
        case 'bkCargo':
            this.bkCargo[prop] = content.toUpperCase();
            break;
        //发货人数据
        case 'shipper':
            this.shipper[prop] = content.toUpperCase();
            break;
        //收货人数据
        case 'consignee':
            this.consignee[prop] = content.toUpperCase();
            break;
        //通知人1数据
        case 'notifier1':
            this.notifier1[prop] = content.toUpperCase();
            break;
        //通知人2数据
        case 'notifier2':
            this.notifier2[prop] = content.toUpperCase();
            break;
        //拆单分单数据
        case 'tableHBLInfo':
            this.tableHBLInfo[index][prop] = content.toUpperCase();
            break;
    }
}

export function convertCurrency(money) {
    console.log(money);
    // 汉字的数字
    let cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    // 基本单位
    let cnIntRadice = ['', '拾', '佰', '仟'];
    // 对应整数部分扩展单位
    let cnIntUnits = ['', '万', '亿'];
    // 对应小数部分单位
    let cnDecUnits = ['角', '分'];
    // 整数金额时后面跟的字符
    let cnInteger = '整';
    // 整型完以后的单位
    let cnIntLast = '元';
    // 最大处理的数字
    let maxNum = 999999999999999.99;
    // 金额整数部分
    let integerNum;
    // 金额小数部分
    let decimalNum;
    // 输出的中文金额字符串
    let chineseStr = '';
    // 分离金额后用的数组，预定义
    let parts;
    if (money == '') {
        return '';
    }
    money = parseFloat(money);
    if (money >= maxNum) {
        // 超出最大处理数字
        return '';
    }
    if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
    }
    // 转换为字符串
    money = money.toString();
    if (money.indexOf('.') == -1) {
        integerNum = money;
        decimalNum = '';
    } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
    }
    // 获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0;
        let IntLen = integerNum.length;
        for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1);
            let p = IntLen - i - 1;
            let q = p / 4;
            let m = p % 4;
            if (n == '0') {
                zeroCount++;
            } else {
                if (zeroCount > 0) {
                    chineseStr += cnNums[0];
                }
                // 归零
                zeroCount = 0;
                chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
            }
            if (m == 0 && zeroCount < 4) {
                chineseStr += cnIntUnits[q];
            }
        }
        chineseStr += cnIntLast;
    }
    // 小数部分
    if (decimalNum != '') {
        let decLen = decimalNum.length;
        for (let i = 0; i < decLen; i++) {
            let n = decimalNum.substr(i, 1);
            if (n != '0') {
                chineseStr += cnNums[Number(n)] + cnDecUnits[i];
            }
        }
    }
    if (chineseStr == '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum == '') {
        chineseStr += cnInteger;
    }
    return chineseStr;
}


function getArrayConcat(array, rowsLimit) {
    let concat = "";
    let rows = array.length;
    if (rows >= 0) {
        array.forEach((item, index) => {
            if (index === 0) {
                concat = item;
            } else if (index > 0 && index < rowsLimit) {
                concat = concat + "\n" + item;
            }
        });
        return concat;
    }
}

function formatChinese2EnglishChar(chineseChar){
    // 将单引号‘’都转换成'，将双引号“”都转换成"
    let str = chineseChar.replace(/[’|‘]/g,"'").replace(/[“|”]/g,"\"");
    // 将中括号【】转换成[]，将大括号｛｝转换成{}
    str = str.replace(/【/g,"[").replace(/】/g,"]").replace(/｛/g,"{").replace(/｝/g,"}").replace(/（/g,"(").replace(/）/g,")");
    // 将逗号，转换成,，将：转换成:
    str = str.replace(/，/g,",").replace(/：/g,":").replace(/；/g,";");
    //将《转换为<，将》转换为>
    str=str.replace(/《/g,"<").replace(/》/g,">");
    //将句号。转换成.，将问号？转换为?
    str=str.replace(/。/g,".").replace(/？/g,"?");
    //将！转换为!
    str=str.replace(/！/g,"!");
    //将￥转换为$
    str=str.replace(/￥/g,"$");
    return str;
}

/**
 * @desc 方法支持：
 * 英文字母（A-Z, a-z）
 * 数字（0-9）
 * 英文符号（ASCII 32-126 范围内的符号）
 * 换行符（\n, \r）
 * 制表符（\t）
 * 仍然会过滤：
 * 中文字符
 * 中文标点
 * 全角字符
 * 其他非ASCII字符（除换行符和制表符外）
 * 用户可以在文本框中输入换行，换行符会被保留，不会被过滤
 * @param parent - 父级属性
 * @param prop - 当前属性
 * @param value - 输入内容
 * @param index - 若为数组，则表示当前数据所在数组中的索引
 * @param maxLength - 可选，最大长度限制，如果传入则校验并截取超长部分
 * @return string
 */
export function formatUpperNoChinese(parent, prop, value, index, maxLength) {
    // 生成字段错误键名（用于存储错误信息）
    // 只有当 index 明确存在且不为 0 时，才使用带索引的键名（用于数组字段）
    // 对于非数组字段，即使传入 0 也使用不带索引的键名
    const errorKey = (index !== undefined && index !== null && index !== 0) 
        ? `${parent}.${prop}.${index}` 
        : `${parent}.${prop}`;
    
    // 确保 fieldErrors 对象存在，如果不存在则初始化
    if (!this.fieldErrors) {
        this.fieldErrors = {};
    }
    
    // 允许空字符串，确保即使过滤后为空也能正确处理
    if (value !== null && value !== undefined) {

        // 验证失败提示信息
        var warningMsg = [];

        // 配置不允许输入空格的字段
        const isNoSpacesField = prop === "bkNo"
            || prop === "blNo"
            || prop === "agreementNo"
            || prop === "applicantUnit"
            || prop === "currentPassWord"
            || prop === "passWord"
            || prop === "checkPass";
        // 配置仅允许输入英文字母及数字的字段
        const isOnlyEngNumField = prop === "bkNo";

        // 检测各种类型的字符
        const chineseChars = value.match(/[\u4e00-\u9fa5]/g);// 仅中文字符（无标点）,对应国际标准中 "常用中文字符" 的范围（包含简体、繁体常用字，共约 2 万多个
        const chinesePunctuation = value.match(/[\u3000-\u303f\uff00-\uffef\u2010-\u206F\u00A0\uFEFF]/g);// 仅中文标点（无字符）,\u3000-\u303f：包含全角空格、顿号、逗号、句号、冒号、分号、引号、括号等（如「 、，。：；""''（）《》」）；\uff00-\uffef：包含全角英文标点、中文特殊标点（如「！@#￥%……&*（）——」、全角的 ！ ？ ， 等）；
        
        // 检测其他语言字符（排除中文汉字和中文标点）
        // 先获取所有非ASCII字符，然后排除中文汉字和中文标点
        const allNonAsciiChars = value.match(/[^\x09\x0A\x0D\x20-\x7F]/g);
        let otherLanguageChars = null;
        if (allNonAsciiChars && allNonAsciiChars.length > 0) {
            // 过滤掉中文汉字和中文标点，剩下的就是其他语言字符
            otherLanguageChars = allNonAsciiChars.filter(char => {
                const isChinese = /[\u4e00-\u9fa5]/.test(char);
                const isChinesePunct = /[\u3000-\u303f\uff00-\uffef\u2010-\u206F\u00A0\uFEFF]/.test(char);
                return !isChinese && !isChinesePunct;
            });
            // 如果过滤后为空数组，则设为null
            if (otherLanguageChars.length === 0) {
                otherLanguageChars = null;
            }
        }
        
        // 根据实际输入内容精准提示（按优先级检测，只显示最新检测到的错误）
        // 优先级：中文汉字 > 中文标点 > 其他语言字符
        if (chineseChars && chineseChars.length > 0) {
            warningMsg = [this.$t("common.chineseChars")];
        } else if (chinesePunctuation && chinesePunctuation.length > 0) {
            warningMsg = [this.$t("common.chinesePunctuation")];
        } else if (otherLanguageChars && otherLanguageChars.length > 0) {
            warningMsg = [this.$t("common.otherLanguageChars")];
        }

        // 只保留英文字母、数字、英文符号和换行符
        // 允许：ASCII 9 (Tab), 10 (LF \n), 13 (CR \r), 32-126 (可打印字符)
        // 移除所有其他非ASCII字符（包括中文、中文标点、全角字符、其他语言字符等）
        let newValue = value.replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
        // 转换为大写
        newValue = newValue.toUpperCase();
        
        // 去掉空白字符（针对特定字段）
        if (isNoSpacesField) {
            newValue = newValue.replace(/\s/g, '');
        }

        // 去掉除英文字母和英文符号外的字符（针对特定字段）
        if (isOnlyEngNumField) {
            // 对于 bkNo 字段，只允许英文字母和数字，清除之前的警告信息
            // 检测是否包含不支持的字符（非英文字母和数字，包括小写字母、符号等）
            // 使用转换为大写后的值进行检测，或者检测原始值中的非字母数字字符
            const unsupportedChars = newValue.match(/[^A-Z0-9]/g);
            if (unsupportedChars && unsupportedChars.length > 0) {
                warningMsg = [this.$t("common.enAndNumSupported")];
            }
            // 只保留大写英文字母和数字，移除其他字符
            newValue = newValue.replace(/[^A-Z0-9]/g, '');
        }

        // 校验并截取最大长度（如果传入了maxLength参数）
        // 注意：超长检测放在最后，如果超长则只显示超长提示（优先级最高）
        if (maxLength !== null && maxLength !== undefined && typeof maxLength === 'number' && maxLength > 0) {
            // 检测输入内容是否超长（使用过滤后的值进行检测）
            // 注意：需要在截取前检测，确保能正确显示提示信息
            if (newValue.length > maxLength) {
                // 输入内容超长，只显示超长提示（覆盖之前的错误提示）
                warningMsg = [this.$t('common.overLength',{maxLength:maxLength})];
                // 截取超长部分
                newValue = newValue.substring(0, maxLength);
            }
        }
        
        // 设置或清除错误信息到 Vue 实例的 fieldErrors 对象中
        // 只显示最新一条错误信息（避免提示内容过长）
        if (warningMsg.length > 0) {
            // 只取最后一条错误信息（按检测顺序，最后检测到的错误优先级最高）
            const errorMsg = warningMsg[warningMsg.length - 1];
            // 确保 fieldErrors 对象已初始化
            if (!this.fieldErrors) {
                if (this.$set) {
                    this.$set(this, 'fieldErrors', {});
                } else {
                    this.fieldErrors = {};
                }
            }
            // 使用 Vue.set 确保响应式更新
            if (this.$set) {
                this.$set(this.fieldErrors, errorKey, errorMsg);
            } else {
                // 如果 fieldErrors 不存在，需要先创建
                if (!this.fieldErrors) {
                    this.fieldErrors = {};
                }
                this.fieldErrors[errorKey] = errorMsg;
            }
            // 强制触发视图更新
            if (this.$forceUpdate) {
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            }
        } else {
            // 校验通过，清除错误信息（使用 delete 或设置为 undefined）
            if (this.fieldErrors && this.fieldErrors[errorKey]) {
                if (this.$set) {
                    this.$set(this.fieldErrors, errorKey, undefined);
                } else {
                    delete this.fieldErrors[errorKey];
                }
                // 强制触发视图更新
                if (this.$forceUpdate) {
                    this.$nextTick(() => {
                        this.$forceUpdate();
                    });
                }
            }
        }

        // 根据parent更新对应的对象属性
        // 使用Vue.set确保响应式更新
        const updateValue = (obj, key, val) => {
            if (this.$set) {
                this.$set(obj, key, val);
            } else {
                obj[key] = val;
            }
        };
        
        switch (parent) {
            //舱单数据
            case 'bookingHead':
                updateValue(this.bookingHead, prop, newValue);
                break;
            //舱单扩展数据
            case 'bkExtend':
                updateValue(this.bkExtend, prop, newValue);
                break;
            //前程运输数据
            case 'bkRoutingPre':
                updateValue(this.bkRoutingPre, prop, newValue);
                break;
            //货物数据
            case 'bkCargo':
                updateValue(this.bkCargo, prop, newValue);
                break;
            //货物-危险品数据
            case 'bkImos':
                if (this.$set && this.bkCargo.bkImos[index]) {
                    this.$set(this.bkCargo.bkImos[index], prop, newValue);
                } else {
                    this.bkCargo.bkImos[index][prop] = newValue;
                }
                break;
            //货物-冷箱数据
            case 'bkReefers':
                if (this.$set && this.bkCargo.bkReefers[index]) {
                    this.$set(this.bkCargo.bkReefers[index], prop, newValue);
                } else {
                    this.bkCargo.bkReefers[index][prop] = newValue;
                }
                break;
            //特种箱数据
            case 'bkAks':
                if (this.$set && this.bookingHead.bkAks[index]) {
                    this.$set(this.bookingHead.bkAks[index], prop, newValue);
                } else {
                    this.bookingHead.bkAks[index][prop] = newValue;
                }
                break;
            //集装箱数据
            case 'bkContainers':
                if (this.$set && this.bkContainers[index]) {
                    this.$set(this.bkContainers[index], prop, newValue);
                } else {
                    this.bkContainers[index][prop] = newValue;
                }
                break;
            case 'editBkContainers':
                if (this.$set && this.editBkContainers[index]) {
                    this.$set(this.editBkContainers[index], prop, newValue);
                } else {
                    this.editBkContainers[index][prop] = newValue;
                }
                break;
            //发货人数据
            case 'shipper':
                updateValue(this.shipper, prop, newValue);
                break;
            //收货人数据
            case 'consignee':
                updateValue(this.consignee, prop, newValue);
                break;
            //通知人1数据
            case 'notifier1':
                updateValue(this.notifier1, prop, newValue);
                break;
            //通知人2数据
            case 'notifier2':
                updateValue(this.notifier2, prop, newValue);
                break;
            //其他数据
            case 'formData':
                updateValue(this.formData, prop, newValue);
                break;
            case 'popover':
                updateValue(this.popover, prop, newValue);
                break;
            case 'search':
                updateValue(this.search, prop, newValue);
                break;
            case 'bkSearch':
                updateValue(this.bkSearch, prop, newValue);
                break;
            case 'tableHBLInfo':
                if (this.$set && this.tableHBLInfo[index]) {
                    this.$set(this.tableHBLInfo[index], prop, newValue);
                } else {
                    this.tableHBLInfo[index][prop] = newValue;
                }
                break;
            //估价单数据
            case 'estimate':
                updateValue(this.estimate, prop, newValue);
                break;
            //估价单数据
            case 'ruleForm':
                updateValue(this.ruleForm, prop, newValue);
                break;
            //修改密码
            case 'pswForm':
                updateValue(this.pswForm, prop, newValue);
                break;
            //对账单明细数据
            case 'statementOfAccount':
                updateValue(this.statementOfAccount, prop, newValue);
                break;
            //发票明细数据
            case 'invoiceDoc':
                updateValue(this.invoiceDoc, prop, newValue);
                break;
            //VGM数据
            case 'vgmContainerUploadTableData':
                updateValue(this.vgmContainerUploadTableData, prop, newValue);
                break;
        }
    }
}

export default {
    formatNumber,
    formatUpper,
    validateSingleLineCharLength,
    formatUpperNoChinese
}